import { render, staticRenderFns } from "./Departament.vue?vue&type=template&id=16f66eac"
import script from "./Departament.vue?vue&type=script&lang=js"
export * from "./Departament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f66eac')) {
      api.createRecord('16f66eac', component.options)
    } else {
      api.reload('16f66eac', component.options)
    }
    module.hot.accept("./Departament.vue?vue&type=template&id=16f66eac", function () {
      api.rerender('16f66eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Departament.vue"
export default component.exports